import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import { ApolloProvider } from '@apollo/react-hooks';

import useDormifyGateway from '../../hooks/useDormifyGateway';

import AccountVisualizerGrid from './AccountVisualizerGrid';

var AccountVisualizerClient = function AccountVisualizerClient(_ref) {
  var addVariantToCart = _ref.addVariantToCart;

  var client = useDormifyGateway();
  if (!window.Dormify.customerId) {
    // if not logged, in, dont do anything
    return null;
  }

  return ReactDOM.createPortal(React.createElement(
    ApolloProvider,
    { client: client },
    React.createElement(AccountVisualizerGrid, { addVariantToCart: addVariantToCart })
  ), document.getElementById('account-visualizer'));
};

AccountVisualizerClient.propTypes = {
  addVariantToCart: PropTypes.func.isRequired
};

export default AccountVisualizerClient;